import { Vertex2 } from '@rta/rta-blueprint-library';

import { BREAKPOINT_SPACING } from './constants';
import { Vector } from '@r-core/types';

export const shiftVectorX = (vector: Vector<Vertex2>): Vector<Vertex2> => ({
	...vector,
	from: new Vertex2({ dataIn: { x: vector.from.x + BREAKPOINT_SPACING, y: vector.from.y }}),
	to: new Vertex2({ dataIn: { x: vector.to.x + BREAKPOINT_SPACING, y: vector.to.y }})
});

